<template>
    <span>
      <h2 class="h-label gray h-label shown-label">
        Datum & Uhrzeit
      </h2>
      <div class="dateTimeInput selection-element-holder">
        <div class="dateTimeInput-row" >
          <h2 class="h-label hidden-label">Datum</h2>
          <div class="selection-element-holder selection relative pointer" v-click-outside="hideDateTable">
          <input readonly :value="datePlaceholder" class="forminput dateInput pointer" v-on:click="showDateTable()" />
          <div class="selection-details-date" v-show="dateTable">
             <v-date-picker is-expanded :min-date="nextDate"  :disabled-dates='disabledDates' v-model="date" />
          </div>
          <div class="dropdown-icon absolute pointer" v-on:click="showDateTable()">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 0C10.1819 0 11.3522 0.232792 12.4442 0.685084C13.5361 1.13738 14.5282 1.80031 15.364 2.63604C16.1997 3.47177 16.8626 4.46392 17.3149 5.55585C17.7672 6.64778 18 7.8181 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C7.8181 18 6.64778 17.7672 5.55585 17.3149C4.46392 16.8626 3.47177 16.1997 2.63604 15.364C0.948211 13.6761 0 11.3869 0 9C0 6.61305 0.948211 4.32387 2.63604 2.63604C4.32387 0.948211 6.61305 0 9 0ZM4.5 7.2L9 11.7L13.5 7.2H4.5Z" fill="#0176CD"/>
            </svg>
          </div>
          <div class="calendar-icon absolute pointer" v-on:click="showDateTable()">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 18H2V7H16V18ZM13 0V2H5V0H3V2H2C0.89 2 0 2.89 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 2.89 17.1 2 16 2H15V0H13ZM14 11H9V16H14V11Z" fill="#0176CD"/>
            </svg>
          </div>
         </div>
        </div>
        <br/>
        <div class="dateTimeInput-row">
          <h2 class="h-label hidden-label">Uhrzeit</h2>
          <div class="selection-element-holder selection relative pointer" v-click-outside="hideTimeList">
              <input readonly :value="timePlaceholder" class="forminput timeInput pointer" v-on:click="showTimeList()"/>
              <div class="selection-details time-list" v-show="timeList">
              <div class="time-pills-box">
                <div class="pill-col col-3 border-box">
                  <button class="time-pill" :class="{pickedpill : time == '10:00'}" @click="pickTime('10:00')">10:00</button>
                  <button class="time-pill" :class="{pickedpill : time == '12:00'}" @click="pickTime('12:00')">12:00</button>
                  <button class="time-pill" :class="{pickedpill : time == '14:00'}" @click="pickTime('14:00')">14:00</button>
                  <button class="time-pill" :class="{pickedpill : time == '16:00'}" @click="pickTime('16:00')">16:00</button>
                </div>
                <div class="pill-col col-3 border-box">
                  <button class="time-pill" :class="{pickedpill : time == '10:30'}" @click="pickTime('10:30')">10:30</button>
                  <button class="time-pill" :class="{pickedpill : time == '12:30'}" @click="pickTime('12:30')">12:30</button>
                  <button class="time-pill" :class="{pickedpill : time == '14:30'}" @click="pickTime('14:30')">14:30</button>
                  <button class="time-pill" :class="{pickedpill : time == '16:30'}" @click="pickTime('16:30')">16:30</button>
                </div>
                <div class="pill-col col-3 border-box">
                  <button class="time-pill" :class="{pickedpill : time == '11:00'}" @click="pickTime('11:00')">11:00</button>
                  <button class="time-pill" :class="{pickedpill : time == '13:00'}" @click="pickTime('13:00')">13:00</button>
                  <button class="time-pill" :class="{pickedpill : time == '15:00'}" @click="pickTime('15:00')">15:00</button>                  
                </div>
                <div class="col-3 border-box">
                  <button class="time-pill" :class="{pickedpill : time == '11:30'}" @click="pickTime('11:30')">11:30</button>
                  <button class="time-pill" :class="{pickedpill : time == '13:30'}" @click="pickTime('13:30')">13:30</button>
                  <button class="time-pill" :class="{pickedpill : time == '15:30'}" @click="pickTime('15:30')">15:30</button>
                </div>
              </div>
            </div>
            <div class="dropdown-icon absolute pointer" v-on:click="showTimeList()">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 0C10.1819 0 11.3522 0.232792 12.4442 0.685084C13.5361 1.13738 14.5282 1.80031 15.364 2.63604C16.1997 3.47177 16.8626 4.46392 17.3149 5.55585C17.7672 6.64778 18 7.8181 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C7.8181 18 6.64778 17.7672 5.55585 17.3149C4.46392 16.8626 3.47177 16.1997 2.63604 15.364C0.948211 13.6761 0 11.3869 0 9C0 6.61305 0.948211 4.32387 2.63604 2.63604C4.32387 0.948211 6.61305 0 9 0ZM4.5 7.2L9 11.7L13.5 7.2H4.5Z" fill="#0176CD"/>
              </svg>
            </div>
            <div class="calendar-icon absolute pointer" v-on:click="showTimeList()">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.14C8.14348 18.14 6.36301 17.4025 5.05025 16.0897C3.7375 14.777 3 12.9965 3 11.14C3 9.28349 3.7375 7.50301 5.05025 6.19025C6.36301 4.8775 8.14348 4.14 10 4.14C11.8565 4.14 13.637 4.8775 14.9497 6.19025C16.2625 7.50301 17 9.28349 17 11.14C17 12.9965 16.2625 14.777 14.9497 16.0897C13.637 17.4025 11.8565 18.14 10 18.14ZM10 2.14C7.61305 2.14 5.32387 3.08821 3.63604 4.77604C1.94821 6.46387 1 8.75305 1 11.14C1 13.5269 1.94821 15.8161 3.63604 17.504C5.32387 19.1918 7.61305 20.14 10 20.14C12.3869 20.14 14.6761 19.1918 16.364 17.504C18.0518 15.8161 19 13.5269 19 11.14C19 8.75305 18.0518 6.46387 16.364 4.77604C14.6761 3.08821 12.3869 2.14 10 2.14ZM10.5 6.14H9V12.14L13.75 14.99L14.5 13.76L10.5 11.39V6.14ZM5.88 1.53L4.6 0L0 3.85L1.29 5.38L5.88 1.53ZM20 3.86L15.4 0L14.11 1.53L18.71 5.39L20 3.86Z" fill="#0176CD"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </span>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import ClickOutside from 'vue-click-outside'
export default {
  
    name: 'DateTimeInput',
    props: {
    },
    data() {
      return {
        // For Date/Time input type
        date: new Date(),
        time: '',       
        nextDate: '',
        disabledDates: { weekdays: [1, 7] },
        dateTable: false,
        timeList: false,
        datePlaceholder: '',
        timePlaceholder: '',
      }
    },
    created() {
        this.time = "10:00";
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.nextDate = tomorrow;
        this.date = tomorrow;
        this.inputDatePlaceholder(today);
        this.inputTimePlaceholder(this.time);

        this.updateDate(this.date);
        this.updateTime(this.time);
        this.dateTable = false;
     },
    // do not forget this section
    directives: {
      ClickOutside
    },
    watch: {
      date: function(newValue, oldValue) {
        if(newValue != oldValue) {
          const today = new Date()
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          var pickedDate = this.date
          if(pickedDate >= tomorrow || pickedDate.toDateString() == tomorrow.toDateString()){
            this.date = newValue
            this.inputDatePlaceholder(this.date);
            this.updateDate(this.date);
            this.dateTable = false;
          }
        }
      },
      time: function(newValue, oldValue) {
        if(newValue != oldValue) {
          this.inputTimePlaceholder(newValue);
          this.updateTime(this.time);
          this.timeList = false;
        }
      },
    },
    methods: {
      pickTime(pickedTime){
        this.time = pickedTime;
      },
      showTimeList(){
        if(this.timeList){
          this.timeList = false;
        }else{
          this.timeList = true;
        }
      },
      showDateTable(){
        if(this.dateTable){
          this.dateTable = false;
        }else{
          this.dateTable = true;
        }
      },
      hideDateTable(){
        if(this.dateTable){
          this.dateTable = false;
        }
      },
      hideTimeList(){
        if(this.timeList){
          this.timeList = false;
        }
      },    
      updateDate(date){
        EventBus.$emit("update_date", {
          date: date,
        });        
      },
      updateTime(time){
        EventBus.$emit("update_time", {
          time: time,
        });        
      },
      inputDatePlaceholder(date){
        var day = date.getDate();
        var year = date.getFullYear();
        var month = '';
        switch (date.getMonth()) {
          case 0:
            month = 'Jan'
            break;
          case 1:
            month = 'Feb'
            break;
          case 2:
            month = 'März'
            break;
          case 3:
            month = 'April'
            break; 
          case 4:
            month = 'Mai'
            break;
          case 5:
            month = 'Juni'
            break;
          case 6:
            month = 'Juli'
            break;
          case 7:
            month = 'Aug'
            break;
          case 8:
            month = 'Sep'
            break;
          case 9:
            month = 'Okt'
            break;
          case 10:
            month = 'Nov'
            break;
          case 11:
            month = 'Dez'
            break;    
          default:
            break;
        }
        this.datePlaceholder = day + '. ' + month + '. ' + year;
      },
      inputTimePlaceholder(time){
        this.timePlaceholder = time;
      },
    }
}
</script>

<style >

.dateTimeInput{
  display: flex;
}

.selection-dates {
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  top: 78%;
  z-index: 99;
  color: #fff;
}

.vc-popover-content{
  margin-top: 0 !important;
}

.vc-popover-caret{
  display: none !important;
}

.shown-label{
  display: block;
}

.hidden-label{
  display: none;
}

.vc-header{
  background-color: #0176CD;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 10px !important;
}
.vc-title,
.vc-title-wrapper{
  color: #fff !important;
  font-weight: 600;
}

.vc-arrow{
  color: #fff !important;
}

.vc-arrow:hover{
  background: transparent !important;
}

.dateInput{
  padding: 14px 16px 14px 44px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.selection-details-date {
  background-color: transparent;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  top: 97%;
  z-index: 99;
  color: #fff;
}

.timeInput{
  padding: 14px 16px 14px 44px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-left: none !important;
}

.dropdown-icon{
  top: 33%;
  right: 2%;
  width: 2rem;
  height: 2rem;
}

.time-pills-box{
  display: flex;
  margin: .5rem;
  text-align: center;  
}

.time-list{
    height: 272.13px;
}

.pill-col{
  margin-right: .5rem;
}

.dateTimeInput-row{
  position: relative;
  width: 50%;
}

.time-pill{
  border: none;
  background: transparent;
  color: #fff;
  padding: .45rem;
  border-radius: 20px;
  font-size: 16px;
}

.time-pill:hover{
  background-color: #0056b1;
  color: #fff;
}

.pickedpill{
  background: #fff;
  color: #0056b1;
}

.forminput:focus-visible {
  border: 2px solid #0176CD;
}

.calendar-icon{
  top: 35%;
  left: 5%;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
}

::placeholder {
  font-style: italic;
  width: 100%;
}

@media(max-width: 525px){
    .hidden-label{
      display: block;
    }

    .shown-label{
      display: none;
    }

    .dateTimeInput{
      flex-direction: column;
    }

    .dateTimeInput-row{
      width: 100%;
    }

    .dateInput{
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
      width: 100%;
    }

    .timeInput{
      border-top-left-radius: 5px !important;
      border-bottom-left-radius: 5px !important;
      border-left: 2px solid #0176CD !important;
    }
}

@media(max-width: 425px){
  .forminput{
    font-size: 1em;
      text-overflow: ellipsis;
  }
  ::placeholder {
    width: 75%;
  }
}
</style>